import { Assets } from "../assets";
import { type } from "../types/typeTexture";

export const createNewArrayTexture = (array = []) => {
	let arrayTextureView360 = [];
	let arrayTexturesSpot = [];
	array.forEach((element, index) => {
		arrayTextureView360.push({
			id: element.id,
			name: `move-${index}`,
			material: element.moveHotSpot,
			type: type.view360,
			position: element.position,
			camarePosition: element.camarePosition,
			moveHotSpotArrow: element.moveHotSpotArrow,
		});
	});
	arrayTexturesSpot.push({
		id: -1,
		name: `spot`,
		material: Assets.hotspot.move,
		type: type.hotspot,
		position: array[0].position,
		moveHotSpotArrow: [],
	});
	return arrayTextureView360.concat(arrayTexturesSpot);
};

export const createNewArrayPlaneTexture = (array = []) => {
	let arrayTextureHotSpot = [];
	let arrayTexturesSpotHover = [];
	array.forEach((element, index) => {
		arrayTextureHotSpot.push({ name: element.name, url: element.hotspot, position: element.position, hover: false });
		arrayTexturesSpotHover.push({ name: element.name, url: element.hotspotHover, position: element.position, hover: true });
	});
	return arrayTextureHotSpot.concat(arrayTexturesSpotHover);
};
